import { render, staticRenderFns } from "./RewardList.vue?vue&type=template&id=036f4bdc&scoped=true&"
import script from "./RewardList.vue?vue&type=script&lang=js&"
export * from "./RewardList.vue?vue&type=script&lang=js&"
import style0 from "./RewardList.vue?vue&type=style&index=0&id=036f4bdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036f4bdc",
  null
  
)

export default component.exports